import { Icon, Label } from '@acast/decibel';
import { CalendarLightGlyph } from '@acast/decibel-glyphs';
import classnames from 'classnames';
import moment from 'moment';
import T from 'prop-types';
import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import isStringISODate from 'shared/helpers/is-string-iso-date';

export default class DateSelect extends Component {
  static propTypes = {
    label: T.string,
    selected: T.string,
    displayFormat: T.string,
    onChange: T.func,
    disabled: T.bool,
  };

  static defaultProps = {
    label: '',
    displayFormat: 'MMMM Do, YYYY',
    disabled: false,
    onChange: () => {
      // eslint-disable-next-line
      console.warn('DateSelect does not have an onChange handler defined');
    },
  };

  onDateChanged = value => {
    const { onChange } = this.props;
    if (typeof onChange === 'function') {
      onChange(value);
    }
  };

  getInputLabel() {
    const { label } = this.props;
    if (typeof label === 'string' && label.length > 0) {
      return <Label>{label}</Label>;
    }
    return null;
  }

  render() {
    const { selected, displayFormat } = this.props;
    const date = isStringISODate(selected) ? moment(selected) : null;

    return (
      <div
        className={classnames('date-select', {
          'date-select--disabled': this.props.disabled,
        })}
      >
        {this.getInputLabel()}
        <DatePicker
          className="date-select__input"
          placeholderText={date && date.isValid() ? '' : 'Please select date'}
          popoverAttachment="top left"
          popoverTargetAttachment="bottom left"
          popoverTargetOffset="0px 0px"
          dateFormat={displayFormat}
          selected={date}
          onChange={this.onDateChanged}
        />
        <Icon glyph={CalendarLightGlyph} />
      </div>
    );
  }
}
